export const PROMOTIONAL_OFFERS_CHANNEL_FEATURE = 'promo-offers-cmpgn';

export const CLIENT_APP_ENABLED_CHANNEL_FEATURE = 'tw-app-sharing-link';

export const CLIENT_APP_CAMPAIGN_CHANNEL_FEATURE = 'app-for-clnts-cmpgn';
